import { State } from "infrontjs";
import { LoginState } from "./../auth/LoginState";

export class InAppState extends State
{
    static ROUTE = null;
    static ID = null;

    canEnter()
    {
        if ( this.app.user !== null )
        {
            return true;
        }
        else
        {
            return false;
        }
    }

    async exit()
    {
        if ( this.app.view.pageContent )
        {
            this.app.view.pageContent.innerHTML = '';
        }
    }

    getRedirectUrl()
    {
        return LoginState.ROUTE;
    }

    getContentHeaderData()
    {
        return {
            title: '',
            breadcrumb: []
        };
    }
}
